import { atom } from "recoil";

export const $ServerUrl = atom({
  key: "$ServerUrl",
  default: "http://abaad.online/api",
  // default: "http://82.112.241.233:1337/api",
  // default: "http://localhost:1337/api",
  // default: "https://www.easetasks.com/abaad",
});
